import React from "react";

// Custom methods
import { isFunction } from "../../../../../../Libs/CustomMethods/customMethods";

//Redux
import { useSelector } from "react-redux";

// Theme style
import "./lightTheme.scss";

const importDarkMode = (mainTheme) => {
  if (mainTheme === "dark") {
    require("./darkTheme.scss");
  }
};

const FavoriteMessage = ({
  msgId,
  enableClick,
  checked,
  order,
  customClass,
  onClick,
}) => {
  const { mainTheme } = useSelector((state) => state.Layout);

  importDarkMode(mainTheme);

  const starIcon = {
    unchecked: "far fa-star",
    checked: "fas fa-star checked",
  };

  return (
    <>
      <div className={`d-flex align-items-center favoriteMessage ${order}`}>
        <i
          onClick={() => enableClick && isFunction(onClick) && onClick()}
          className={`${checked ? starIcon.checked : starIcon.unchecked} ${
            enableClick ? "starEnabled" : ""
          } ${customClass} p-1`}
        ></i>
      </div>
    </>
  );
};
export default React.memo(FavoriteMessage);
